import { FilterOption } from "@/types";

export const getOption = (name: string, options: FilterOption[]): string => {
  if (!name || !Array.isArray(options)) {
    return "";
  }
  return options.find((option) => option.name === name)?.label || "";
};
